import { Component } from "solid-js";
import HeaderModal from "./HeaderModal";
import modalStyles from "bundle-text:../styles/_defaultmodal.scss";

interface ModalProps {
  show: boolean;
  topBar?: number;
  children: any;
}

const DefaultModal: Component<ModalProps> = (props) => {
  return (
    <>
      {props.show && (
        <div class="default-modal" classList={{ show: props.show }}>
          <style>{modalStyles}</style>
          <div class="content">
            {props.topBar && (
              <progress
                class="progress-bar"
                value={props.topBar}
                max="100"
              ></progress>
            )}
            {props.children}
          </div>
        </div>
      )}
    </>
  );
};

export default DefaultModal;
